import { DynamicControl } from '@shared/models/dynamic-form-control.model';

export class DropdownControl extends DynamicControl<string> {
    controlType = 'dropdown';
    options: { key: string, value: string }[] = [];

    constructor(options: {} = {}) {
        super(options);
        this.options = options['options'] || [];
        this.options.sort(function(a, b) {
            const textA = a.key.toUpperCase();
            const textB = b.key.toUpperCase();
            if (textA < textB) { return -1; }
            if (textA > textB) { return 1; }
            return 0;
        });
    }
}
